import React from 'react'

const VendorBalance = (props) => {
   const parentData = props;

  return (
    <div className="card card-borderless p-1">
      {props.vendorBalance.length ? <table
      border="1"
      cellPadding="10"
      cellSpacing="0"
      style={{ width: "100%" }}
    >
      <thead>
        <tr style={{ backgroundColor: "#EAF2E3" }}>
          <th style={{fontWeight:"bold"}}>Vendor Name</th>
          <th style={{fontWeight:"bold"}}>Company Name</th>
          <th style={{fontWeight:"bold"}} className="text-end">Total Amount</th>
          <th style={{fontWeight:"bold"}} className="text-end">Paid Amount</th>
          <th style={{fontWeight:"bold"}} className="text-end">Balance Amount</th>
        </tr>
      </thead>
      <tbody>
        {parentData.vendorBalance.map((item, index) => (
          <tr key={index}>
            <td>{item.vendorName}</td>
            <td>{item.companyName}</td>
            <td className="text-end">
                      {parentData.currency + " " + item.totalAmount.toFixed(2)}
                    </td>
                    <td className="text-end">
                      {parentData.currency + " " + item.paidAmount.toFixed(2)}
                    </td>
                    <td className="text-end border-0">
                      {parentData.currency + " " + item.balancePayment.toFixed(2)}
                    </td>
          </tr>
        ))}
      </tbody>
    </table> : <div className="card card-borderless p-1 justify-content-center align-items-center text-center" style={{height:"400px"}}>
              No data
            </div>}
    
  </div>
  )
}

export default VendorBalance